// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { responseMetadataSchema } from '@/api/types';
import { dateTimeSchema } from '@/utilities/date-time-schema';
import { z } from 'zod';

export const urlLinkSchema = z.object({
  id: z.string(),
  key: z.string(),
  name: z.string().nullable(),
  url: z.string(),
  createdAt: dateTimeSchema,
  updatedAt: dateTimeSchema,
});

export type URLLink = z.infer<typeof urlLinkSchema>;

export const urlLinksResponseSchema = z.object({
  data: z.array(urlLinkSchema),
  metadata: responseMetadataSchema,
});

/**
 * Parameters for adding a URL link to an entity.
 */
export interface AddURLLinkParams {
  /** Unique identifier (key) of the entity to associate the link with */
  entityKey: string;
  /** Display name for the link (optional) */
  name: string | null;
  /** URL to link to */
  url: string;
}
